import cn from 'clsx'

import { Copy } from 'shared-components'

import Share from './Share'

import s from './Content.module.sass'

function Content({ post }: any) {
    const { copy } = post

    return (
        <section className={s.Content}>
            <div className={cn(s.Cont, 'container')}>
                {copy && (
                    <div className={s.Copy}>
                        <Copy copy={copy} />
                    </div>
                )}
                <Share />
            </div>
        </section>
    )
}

export default Content
